import { MutationTree } from 'vuex';
import { State } from './state';
import { Listeartikel } from '@/modules/ewwms/models/Lager/ListeartikelModels';

export enum MutationTypes {
  SetBestand = 'SETBESTAND',
  AddOrUpdateBestand = 'ADDORUPDATEBESTAND',
  RemoveBestand = 'REMOVEBESTAND',
}

export type Mutations = {
  [MutationTypes.SetBestand](state: State, data: Array<Listeartikel>): void;
  [MutationTypes.AddOrUpdateBestand](state: State, data: Listeartikel): void;
  [MutationTypes.RemoveBestand](state: State, data: number): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SetBestand](state, data) {
    state.bestand = data;
    sessionStorage.setItem('bestand', JSON.stringify(state.bestand));
  },

  [MutationTypes.AddOrUpdateBestand](state, data) {
    const index = state.bestand.findIndex((b) => b.id == data.id);
    if (index === -1) {
      state.bestand.push(data);
    } else {
      state.bestand.splice(index, 1, data);
    }

    sessionStorage.setItem('bestand', JSON.stringify(state.bestand));
  },

  [MutationTypes.RemoveBestand](state, data) {
    const index = state.bestand.findIndex((b) => b.id == data);
    state.bestand.splice(index, 1);
    sessionStorage.setItem('bestand', JSON.stringify(state.bestand));
  },
};
